<template>
    <div>
        <bc-circle-loader v-if="loading == true"></bc-circle-loader>
        <v-container v-else fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{
                            purchase_order.purchase_order_id ? $t("lang.edit_purchase_order") : $t("lang.add_purchase_order")
                        }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="purchase_order.purchase_order_id && purchase_order.purchase_order_id > 0"
                            @invoke-method="refresh(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="purchase_order.purchase_order_id && purchase_order.purchase_order_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print Purchase Order </v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="current_user.login_type_id == '1'" @click="setEmailDialog()">
                                    <v-list-tile-title>Email Purchase Order</v-list-tile-title>
                                </v-list-tile>
                                <v-divider v-if="current_user.login_type_id == '1'" class="ml-3 my-0"></v-divider>
                                <v-list-tile @click="convertToBill()" v-if="purchase_order.status_id != 66 && current_user.login_type_id == '1'">
                                    <v-list-tile-title> Convert to Bill </v-list-tile-title>
                                </v-list-tile>
                                <!-- <v-list-tile v-if="current_user.login_type_id == '1'" @click="receive()">
                                    <v-list-tile-title> Receive </v-list-tile-title>
                                </v-list-tile> -->
                                <!--<template v-if="hasPerm('purchase_orders.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in purchase_order_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != purchase_order.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>-->
                                <v-divider class="ml-3 my-0"></v-divider>
                                <v-list-tile @click="flipCurrency" v-if="current_user.login_type_id != '3'">
                                    <v-list-tile-title v-if="convert_currency">View as Company</v-list-tile-title>
                                    <v-list-tile-title v-else>View as Vendor</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="hasPerm('purchase_orders.approval')" @click="approveUnapprovePurchaseOrder()">
                                    <v-list-tile-title>{{ purchase_order.approved == 1 ? "Unapprove" : "Approve" }}</v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('purchase_orders.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_purchase_order.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'purchase_orders' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-container fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <bc-transaction-links :items="purchase_order.transaction_links" :object_id="purchase_order.purchase_order_id"></bc-transaction-links>
                    <v-flex :class="purchase_order.purchase_order_id != null ? 'lg10 md9 xs12' : 'lg12 md12 xs12'" pb-0 mb-0>
                        <v-card elevation="0">
                            <v-card-text :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                                <div v-if="purchase_order.status" class="ribbon ribbon-top-right" :class="`ribbon-${purchase_order.status_class}`">
                                    <span class="ribbon-span">{{ purchase_order.status }}</span>
                                </div>

                                <vue-perfect-scrollbar
                                    class="scroll-area"
                                    :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                                >
                                    <v-form ref="formPurchaseOrder">
                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                            <v-flex xs12 sm6 row-2-fr1>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12>
                                                        <bc-autocomplete
                                                            v-if="
                                                                purchase_order.purchase_order_id == null &&
                                                                purchase_order.purchase_order_details.length <= 0 &&
                                                                current_user.login_type_id == '1'
                                                            "
                                                            v-model="purchase_order.company_id"
                                                            :label="`${$t('lang.vendor')} *`"
                                                            :items="vendor_options"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('purchase_orders.company_id')"
                                                            @change="selectCustomer(purchase_order.company_id)"
                                                        ></bc-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            :value="
                                                                purchase_order.company
                                                                    ? purchase_order.company
                                                                    : vendor_options.find((item) => item.company_id == purchase_order.company_id).company
                                                            "
                                                            :label="$t('lang.vendor')"
                                                            disabled
                                                            append-icon="lock"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <div class="customer-address" style="padding: 12px">
                                                            <h3>
                                                                {{ $t("lang.billing_address_id") }}
                                                            </h3>
                                                            <div>
                                                                <div>{{ $t("lang.org_bill_location_label") }}</div>
                                                                <div>{{ $t("lang.org_bill_address1") }}</div>
                                                                <div v-if="$t('lang.org_bill_address2') != ''">
                                                                    {{ $t("lang.org_bill_address1") }}
                                                                </div>
                                                                <div>
                                                                    {{ $t("lang.org_bill_city") }}, {{ $t("lang.org_bill_state") }},
                                                                    {{ $t("lang.org_bill_zip_code") }}
                                                                </div>
                                                                <div>{{ $t("lang.org_bill_country_iso_3") }}</div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <div class="customer-address" v-if="purchase_order.company_id" style="padding: 12px">
                                                            <h3>
                                                                {{ $t("lang.shipping_address_id") }}
                                                                <v-btn
                                                                    v-if="current_user.login_type_id == '1'"
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('ship_address')"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div v-if="purchase_order.ship_location_label">{{ purchase_order.ship_location_label }}</div>
                                                                <div>{{ purchase_order.ship_address1 }}</div>
                                                                <div v-if="purchase_order.ship_address2 != ''">
                                                                    {{ purchase_order.ship_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ purchase_order.ship_city }}, {{ purchase_order.ship_state }},
                                                                    {{ purchase_order.ship_zip_code }}
                                                                </div>
                                                                <div>{{ purchase_order.ship_country_iso_3 }}</div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm6>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-if="purchase_order.purchase_order_id"
                                                        v-model="purchase_order.purchase_order_id"
                                                        :label="$t('lang.purchase_order_id')"
                                                        :counter="showCounter(purchase_order.purchase_order_id, 'purchase_orders.purchase_order_id')"
                                                        :rules="ifValid('purchase_orders.purchase_order_id')"
                                                        disabled
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-if="current_user.login_type_id == '1'"
                                                            v-model="purchase_order.order_date"
                                                            :label="$t('lang.order_date')"
                                                            :rules="ifValid('purchase_orders.order_date')"
                                                        ></bc-date-picker>
                                                        <v-text-field
                                                            v-else
                                                            v-model="purchase_order.order_date"
                                                            :label="$t('lang.order_date')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-if="current_user.login_type_id == '1'"
                                                            v-model="purchase_order.payment_term_id"
                                                            :label="$t('lang.payment_term')"
                                                            :items="payment_terms"
                                                            item-value="payment_term_id"
                                                            item-text="description"
                                                            :rules="ifValid('purchase_orders.payment_term_id')"
                                                        ></bc-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            v-model="purchase_order.payment_term"
                                                            :label="$t('lang.payment_term')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-if="
                                                                current_user.login_type_id == '1' ||
                                                                (current_user.login_type_id == '3' &&
                                                                    (purchase_order.status_slug == 'approved' || purchase_order.status_slug == 'open'))
                                                            "
                                                            v-model="purchase_order.expected_delivery_date"
                                                            :label="$t('lang.expected_delivery_date')"
                                                            :rules="ifValid('purchase_orders.expected_delivery_date')"
                                                        ></bc-date-picker>
                                                        <v-text-field
                                                            v-else
                                                            v-model="purchase_order.expected_delivery_date"
                                                            :label="$t('lang.expected_delivery_date')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-if="
                                                                current_user.login_type_id == '1' ||
                                                                (current_user.login_type_id == '3' &&
                                                                    (purchase_order.status_slug == 'approved' || purchase_order.status_slug == 'open'))
                                                            "
                                                            v-model="purchase_order.proforma_invoice_number"
                                                            :label="$t('lang.proforma_invoice_number')"
                                                            :rules="ifValid('purchase_orders.proforma_invoice_number')"
                                                        ></v-text-field>
                                                        <v-text-field
                                                            v-else
                                                            v-model="purchase_order.proforma_invoice_number"
                                                            :label="$t('lang.proforma_invoice_number')"
                                                            :rules="ifValid('purchase_orders.proforma_invoice_number')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-if="current_user.login_type_id == '1'"
                                                            v-model="purchase_order.shipping_carrier_id"
                                                            :label="$t('lang.shipping_carrier_id')"
                                                            :items="filter_shipping_carriers"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('purchase_orders.shipping_carrier_id')"
                                                        ></bc-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            v-model="purchase_order.shipping_carrier"
                                                            :label="$t('lang.shipping_carrier_id')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-if="current_user.login_type_id == '1'"
                                                            v-model="purchase_order.freight_term_id"
                                                            :label="$t('lang.freight_term_id')"
                                                            :items="filter_freight_terms"
                                                            item-value="option_id"
                                                            item-text="option"
                                                            :rules="ifValid('purchase_orders.freight_term_id')"
                                                        ></bc-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            v-model="purchase_order.freight_term"
                                                            :label="$t('lang.freight_term_id')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-if="current_user.login_type_id == '1'"
                                                            v-model="purchase_order.currency_id"
                                                            :label="$t('lang.document_currency')"
                                                            :items="filter_currencies"
                                                            item-value="currency_id"
                                                            item-text="name"
                                                            :rules="ifValid('purchase_orders.currency_id')"
                                                            @change="setExchangeRate(purchase_order.currency_id)"
                                                        ></bc-autocomplete>
                                                        <v-text-field
                                                            v-else
                                                            v-model="purchase_order.currency_name"
                                                            :label="$t('lang.document_currency')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="purchase_order.exchange_rate"
                                                            :label="$t('lang.exchange_rate')"
                                                            :counter="showCounter(purchase_order.exchange_rate, 'purchase_orders.exchange_rate')"
                                                            :rules="ifValid('purchase_orders.exchange_rate')"
                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="purchase_order.work_order_no"
                                                            :label="$t('lang.work_order_no')"
                                                            :rules="ifValid('purchase_orders.work_order_no')"
                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6 v-if="current_user.login_type_id == '1'">
                                                        <bc-autocomplete
                                                            v-model="purchase_order.project_id"
                                                            :label="`${$t('lang.project')}`"
                                                            :items="projects"
                                                            item-value="project_id"
                                                            item-text="project_name"
                                                            :rules="ifValid('purchase_orders.project_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="purchase_order.customer_po"
                                                            :label="$t('lang.customer_po')"
                                                            :rules="ifValid('purchase_orders.customer_po')"
                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="purchase_order.attention_to"
                                                            :label="$t('lang.attention_to')"
                                                            :rules="ifValid('purchase_orders.attention_to')"
                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12>
                                                        <v-text-field
                                                            v-model="purchase_order.vendor_quote_number"
                                                            :label="$t('lang.vendor_quote_number')"
                                                            :rules="ifValid('purchase_orders.vendor_quote_number')"
                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>

                                        <div>
                                            <v-data-table
                                                :headers="purchase_order_headers"
                                                :items="purchase_order.purchase_order_details || []"
                                                item-key="purchase_order_detail_id"
                                                :no-data-text="$t('lang.no_results_matching')"
                                                hide-actions
                                                class="custom-table"
                                            >
                                                <template slot="items" slot-scope="props">
                                                    <tr>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-if="props.item.part_id == null"
                                                                v-model="props.item.map_id"
                                                                :items="fe_part_options_by_vendor || []"
                                                                item-value="vendor_map_id"
                                                                item-text="vendor_sku"
                                                                @change="handleChangePart(props.index, props.item)"
                                                                :rules="ifValid('purchase_orders.purchase_order_details.map_id')"
                                                                :filter="$filterFeParts"
                                                                hide-details
                                                                :ref="`${props.index}_map_id`"
                                                                :disabled="current_user.login_type_id == '1' ? false : true"
                                                            >
                                                                <template slot="item" slot-scope="data">
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title
                                                                            ><strong>{{ data.item.vendor_sku }}</strong></v-list-tile-title
                                                                        >
                                                                        <v-list-tile-sub-title>{{ `Name: ${data.item.name}` }}</v-list-tile-sub-title>
                                                                        <v-list-tile-sub-title>{{ `Model: ${data.item.model_number}` }}</v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </template>
                                                            </bc-autocomplete>
                                                            <v-list-tile v-else class="full-height-tile">
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title
                                                                        ><strong>{{ props.item.vendor_sku || props.item.sku }}</strong></v-list-tile-title
                                                                    >
                                                                    <v-list-tile-sub-title>{{ `Name: ${props.item.name}` }}</v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title>{{ `Model: ${props.item.model_number}` }}</v-list-tile-sub-title>
                                                                    <v-textarea
                                                                        class="custom-textarea"
                                                                        outline
                                                                        v-model="props.item.line_description"
                                                                        placeholder="Add a description to your item"
                                                                        hide-details
                                                                        style="width: 100%"
                                                                        :rules="ifValid('purchase_orders.purchase_order_details.line_description')"
                                                                        auto-grow
                                                                        rows="1"
                                                                        :disabled="current_user.login_type_id == '1' ? false : true"
                                                                    ></v-textarea>
                                                                </v-list-tile-content>
                                                                <v-list-tile-action
                                                                    v-if="current_user.login_type_id == '1'"
                                                                    style="position: absolute; top: 0px; right: 0px; align-items: normal"
                                                                >
                                                                    <v-btn icon ripple @click="resetLine(props.index, props.item)">
                                                                        <v-icon color="grey lighten-1">cancel</v-icon>
                                                                    </v-btn>
                                                                </v-list-tile-action>
                                                            </v-list-tile>
                                                            <!-- <small v-if="props.item.map_id" class="fs-12">{{ props.item.name }}</small>
                                                            <br />
                                                            <small v-if="props.item.map_id" class="fs-12">{{ props.item.model_number }}</small> -->
                                                        </td>
                                                        <!-- <td>
                                                            <v-text-field v-model="props.item.name" :placeholder="$t('lang.name')" disabled></v-text-field>
                                                            <v-text-field
                                                                v-model="props.item.model_number"
                                                                :placeholder="$t('lang.model_number')"
                                                                disabled
                                                            ></v-text-field>
                                                            <v-text-field
                                                                v-model="props.item.mfg_name"
                                                                :placeholder="$t('lang.mfg_name')"
                                                                disabled
                                                            ></v-text-field>
                                                        </td> -->
                                                        <td>
                                                            {{ props.item.mfg_name }}
                                                        </td>
                                                        <td>
                                                            <v-text-field v-model="props.item.hts_code" disabled></v-text-field>
                                                        </td>
                                                        <td>
                                                            <div style="display: flex; align-items: center">
                                                                <v-text-field
                                                                    v-model="props.item.quantity"
                                                                    :counter="
                                                                        showCounter(props.item.quantity, 'purchase_orders.purchase_order_details.quantity')
                                                                    "
                                                                    :rules="ifValid('purchase_orders.purchase_order_details.quantity')"
                                                                    :ref="`${props.index}_quantity`"
                                                                    :disabled="current_user.login_type_id == '1' ? false : true"
                                                                >
                                                                    <div
                                                                        slot="append"
                                                                        v-if="props.item.purchase_order_detail_id && current_user.login_type_id == '1'"
                                                                    >
                                                                        <bc-tooltip
                                                                            top
                                                                            v-if="props.item.in_transit_quantity == null || props.item.in_transit_quantity > 0"
                                                                        >
                                                                            <template slot="activator">
                                                                                <v-icon
                                                                                    @click="
                                                                                        setupPurchaseOrderReceiveProduct(props.item.purchase_order_detail_id)
                                                                                    "
                                                                                    :color="props.item.in_transit_class"
                                                                                    >{{ props.item.in_transit_icon }}</v-icon
                                                                                >
                                                                            </template>
                                                                            Click to Receive this Product
                                                                        </bc-tooltip>
                                                                        <bc-tooltip top v-else>
                                                                            <template slot="activator">
                                                                                <v-icon :color="props.item.in_transit_class">{{
                                                                                    props.item.in_transit_icon
                                                                                }}</v-icon>
                                                                            </template>
                                                                            This Product has been received
                                                                        </bc-tooltip>
                                                                    </div>
                                                                </v-text-field>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-model="props.item.sales_unit"
                                                                :items="filter_sales_units(props.item)"
                                                                item-value="option_id"
                                                                item-text="option"
                                                                :rules="ifValid('purchase_orders.purchase_order_details.sales_unit')"
                                                                :disabled="current_user.login_type_id == '1' ? false : true"
                                                            ></bc-autocomplete>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.lead_time"
                                                                :disabled="current_user.login_type_id == '1' ? false : true"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && purchase_order.currency_prefix != null
                                                                        ? purchase_order.currency_prefix
                                                                        : '$'
                                                                "
                                                                :suffix="
                                                                    convert_currency == true && purchase_order.currency_suffix != null
                                                                        ? purchase_order.currency_suffix
                                                                        : ''
                                                                "
                                                                v-model="props.item.cost_price"
                                                                :counter="
                                                                    showCounter(props.item.cost_price, 'purchase_orders.purchase_order_details.cost_price')
                                                                "
                                                                :rules="ifValid('purchase_orders.purchase_order_details.cost_price')"
                                                                :disabled="current_user.login_type_id == '1' ? false : true"
                                                            ></v-text-field>
                                                        </td>
                                                        <td style="display: flex">
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-if="props.item.line_discount_type == 'P'"
                                                                v-model="props.item.line_discount_percentage"
                                                                :disabled="current_user.login_type_id == '1' ? false : true"
                                                            ></v-text-field>
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-else-if="props.item.line_discount_type == 'A'"
                                                                v-model="props.item.line_discount_amount"
                                                                :disabled="current_user.login_type_id == '1' ? false : true"
                                                            ></v-text-field>
                                                            <v-btn
                                                                x-small
                                                                raised
                                                                class="ma-0 pa-0"
                                                                style="min-width: 25px !important"
                                                                @click="setDetailDiscount(props.index)"
                                                                :disabled="current_user.login_type_id == '1' ? false : true"
                                                            >
                                                                {{
                                                                    convert_currency == true
                                                                        ? purchase_order.currency_prefix != null && props.item.line_discount_type == "A"
                                                                            ? purchase_order.currency_prefix
                                                                            : "%"
                                                                        : props.item.line_discount_type == "P"
                                                                        ? "%"
                                                                        : "$"
                                                                }}
                                                            </v-btn>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && purchase_order.currency_prefix != null
                                                                        ? purchase_order.currency_prefix
                                                                        : '$'
                                                                "
                                                                v-model="props.item.line_total"
                                                                disabled
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-icon
                                                                v-if="
                                                                    current_user.login_type_id == '1' &&
                                                                    (props.item.in_transit_quantity > 0 || props.item.in_transit_quantity == null)
                                                                "
                                                                @click="removeRow(props.index)"
                                                                >delete</v-icon
                                                            >
                                                        </td>
                                                    </tr>
                                                    <!-- <tr v-else>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-model="props.item.map_id"
                                                                :items="fe_part_options_by_vendor || []"
                                                                item-value="vendor_map_id"
                                                                item-text="vendor_sku"
                                                                @change="handleChangePart(props.index, props.item)"
                                                                :rules="ifValid('purchase_orders.purchase_order_details.map_id')"
                                                                append-icon="lock"
                                                                disabled
                                                            ></bc-autocomplete>
                                                        </td>
                                                        <td>
                                                            <v-text-field v-model="props.item.name" :placeholder="$t('lang.name')" disabled></v-text-field>
                                                            <v-text-field
                                                                v-model="props.item.model_number"
                                                                :placeholder="$t('lang.model_number')"
                                                                disabled
                                                            ></v-text-field>
                                                            <v-text-field
                                                                v-model="props.item.mfg_name"
                                                                :placeholder="$t('lang.mfg_name')"
                                                                disabled
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field v-model="props.item.hts_code" disabled></v-text-field>
                                                        </td>
                                                        <td>
                                                            <div style="display: flex; align-items: center">
                                                                <v-text-field
                                                                    v-model="props.item.quantity"
                                                                    :counter="
                                                                        showCounter(props.item.quantity, 'purchase_orders.purchase_order_details.quantity')
                                                                    "
                                                                    :rules="ifValid('purchase_orders.purchase_order_details.quantity')"
                                                                    :ref="`${props.index}_quantity`"
                                                                    disabled
                                                                >
                                                                </v-text-field>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-model="props.item.sales_unit"
                                                                :items="filter_sales_units(props.item)"
                                                                item-value="option_id"
                                                                item-text="option"
                                                                :rules="ifValid('purchase_orders.purchase_order_details.sales_unit')"
                                                                append-icon="lock"
                                                                disabled
                                                            ></bc-autocomplete>
                                                        </td>
                                                        <td>
                                                            <v-text-field v-model="props.item.lead_time" disabled></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && purchase_order.currency_prefix != null
                                                                        ? purchase_order.currency_prefix
                                                                        : '$'
                                                                "
                                                                :suffix="
                                                                    convert_currency == true && purchase_order.currency_suffix != null
                                                                        ? purchase_order.currency_suffix
                                                                        : ''
                                                                "
                                                                v-model="props.item.cost_price"
                                                                :counter="
                                                                    showCounter(props.item.cost_price, 'purchase_orders.purchase_order_details.cost_price')
                                                                "
                                                                :rules="ifValid('purchase_orders.purchase_order_details.cost_price')"
                                                                disabled
                                                            ></v-text-field>
                                                        </td>
                                                        <td style="display: flex">
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-if="props.item.line_discount_type == 'P'"
                                                                v-model="props.item.line_discount_percentage"
                                                                suffix="%"
                                                                disabled
                                                            ></v-text-field>
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-else-if="props.item.line_discount_type == 'A'"
                                                                v-model="props.item.line_discount_amount"
                                                                :prefix="
                                                                    convert_currency == true && purchase_order.currency_prefix != null
                                                                        ? purchase_order.currency_prefix
                                                                        : '$'
                                                                "
                                                                disabled
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && purchase_order.currency_prefix != null
                                                                        ? purchase_order.currency_prefix
                                                                        : '$'
                                                                "
                                                                v-model="props.item.line_total"
                                                                disabled
                                                            ></v-text-field>
                                                        </td>
                                                        <td></td>
                                                    </tr> -->
                                                </template>
                                            </v-data-table>
                                        </div>
                                        <v-card class="mx-auto mb-4" elevation="0">
                                            <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                    <v-flex xs12 sm8>
                                                        <v-container fluid class="pa-0">
                                                            <v-btn v-if="current_user.login_type_id == '1'" x-small raised color="primary" @click="addRow()">{{
                                                                $t("lang.add_more")
                                                            }}</v-btn>
                                                        </v-container>
                                                    </v-flex>
                                                    <v-flex xs12 sm4>
                                                        <table style="width: 100%">
                                                            <tbody>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">
                                                                        {{ $t("lang.subtotal") }}
                                                                    </th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && purchase_order.currency_prefix != null
                                                                                    ? purchase_order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && purchase_order.currency_suffix != null
                                                                                    ? purchase_order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="purchase_order.subtotal"
                                                                            :counter="showCounter(purchase_order.subtotal, 'purchase_orders.subtotal')"
                                                                            :rules="ifValid('purchase_orders.subtotal')"
                                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.discount") }}</th>
                                                                    <td>
                                                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                                            <v-flex
                                                                                :class="[
                                                                                    $bp.smallScreen ? 'pl-0' : null,
                                                                                    current_user.login_type_id == '1' ? 'xs11' : 'xs12',
                                                                                ]"
                                                                                class="pr-3"
                                                                            >
                                                                                <v-text-field
                                                                                    v-if="purchase_order.discount_type == 'A'"
                                                                                    v-model="purchase_order.discount"
                                                                                    :counter="showCounter(purchase_order.discount, 'purchase_orders.discount')"
                                                                                    :rules="ifValid('purchase_orders.discount')"
                                                                                    :prefix="
                                                                                        convert_currency == true && purchase_order.currency_prefix != null
                                                                                            ? purchase_order.currency_prefix
                                                                                            : '$'
                                                                                    "
                                                                                    :disabled="current_user.login_type_id != '1' ? true : false"
                                                                                ></v-text-field>
                                                                                <v-text-field
                                                                                    v-else
                                                                                    v-model="purchase_order.discount"
                                                                                    :counter="showCounter(purchase_order.discount, 'purchase_orders.discount')"
                                                                                    :rules="ifValid('purchase_orders.discount')"
                                                                                    :suffix="current_user.login_type_id != '1' ? '%' : ''"
                                                                                    :disabled="current_user.login_type_id != '1' ? true : false"
                                                                                ></v-text-field>
                                                                            </v-flex>
                                                                            <v-flex v-if="current_user.login_type_id == '1'" xs1 class="pl-0">
                                                                                <v-container fluid class="pa-0">
                                                                                    <v-btn
                                                                                        class="ma-0 pa-0"
                                                                                        x-small
                                                                                        raised
                                                                                        style="min-width: 25px !important"
                                                                                        @click="setDiscount(purchase_order.discount_type)"
                                                                                        >{{
                                                                                            convert_currency == true
                                                                                                ? purchase_order.currency_prefix != null &&
                                                                                                  purchase_order.discount_type == "A"
                                                                                                    ? purchase_order.currency_prefix
                                                                                                    : "%"
                                                                                                : purchase_order.discount_type == "P"
                                                                                                ? "%"
                                                                                                : "$"
                                                                                        }}</v-btn
                                                                                    >
                                                                                </v-container>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.freight") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && purchase_order.currency_prefix != null
                                                                                    ? purchase_order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && purchase_order.currency_suffix != null
                                                                                    ? purchase_order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="purchase_order.freight"
                                                                            :counter="showCounter(purchase_order.freight, 'purchase_orders.freight')"
                                                                            :rules="ifValid('purchase_orders.freight')"
                                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.customs") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && purchase_order.currency_prefix != null
                                                                                    ? purchase_order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && purchase_order.currency_suffix != null
                                                                                    ? purchase_order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="purchase_order.customs"
                                                                            :counter="showCounter(purchase_order.customs, 'purchase_orders.customs')"
                                                                            :rules="ifValid('purchase_orders.customs')"
                                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.expedite_fee") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && purchase_order.currency_prefix != null
                                                                                    ? purchase_order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && purchase_order.currency_suffix != null
                                                                                    ? purchase_order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="purchase_order.expedite_fee"
                                                                            :counter="showCounter(purchase_order.expedite_fee, 'purchase_orders.expedite_fee')"
                                                                            :rules="ifValid('purchase_orders.expedite_fee')"
                                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.handling_charge") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && purchase_order.currency_prefix != null
                                                                                    ? purchase_order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && purchase_order.currency_suffix != null
                                                                                    ? purchase_order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="purchase_order.handling_charge"
                                                                            :counter="
                                                                                showCounter(purchase_order.handling_charge, 'purchase_orders.handling_charge')
                                                                            "
                                                                            :rules="ifValid('purchase_orders.handling_charge')"
                                                                            :disabled="current_user.login_type_id != '1' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.total_amount") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && purchase_order.currency_prefix != null
                                                                                    ? purchase_order.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && purchase_order.currency_suffix != null
                                                                                    ? purchase_order.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="purchase_order.total_amount"
                                                                            :counter="showCounter(purchase_order.total_amount, 'purchase_orders.total_amount')"
                                                                            :rules="ifValid('purchase_orders.total_amount')"
                                                                            disabled
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                        <v-flex xs12>
                                            <v-textarea
                                                v-model="purchase_order.comments"
                                                :label="$t('lang.comments')"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('purchase_orders.comments')"
                                                :disabled="current_user.login_type_id != '1' ? true : false"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <bc-autocomplete
                                                v-model="purchase_order.department_id"
                                                :label="$t('lang.department')"
                                                :items="department_options"
                                                item-value="department_id"
                                                item-text="department_name"
                                                :rules="ifValid('purchase_orders.department_id')"
                                                :disabled="current_user.login_type_id != '1' ? true : false"
                                                :append-icon="current_user.login_type_id == '1' ? 'arrow_drop_down' : 'lock'"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-form>
                                </vue-perfect-scrollbar>
                            </v-card-text>
                            <v-card-actions v-if="(!convert_currency && hasPerm('purchase_orders.approval')) || purchase_order.approved == 1">
                                <v-spacer></v-spacer>
                                <v-btn @mouseup.left="$router.push({ name: 'purchase_orders' })" flat>{{ $t("lang.cancel") }}</v-btn>
                                <v-btn
                                    v-if="
                                        current_user.login_type_id == '1' ||
                                        (current_user.login_type_id == '3' &&
                                            (purchase_order.status_slug == 'approved' || purchase_order.status_slug == 'open'))
                                    "
                                    color="success"
                                    @click="savePurchaseOrders"
                                    >{{ $t("lang.save") }}</v-btn
                                >
                            </v-card-actions>
                            <div v-else-if="convert_currency" style="width: 100%" class="pa-0">
                                <v-alert style="width: 100%; padding: 12px !important" :value="true" type="warning" color="#f78c00">{{
                                    $t("lang.warn_viewing_as_vendor")
                                }}</v-alert>
                            </div>
                            <div v-else style="width: 100%" class="pa-0">
                                <v-alert style="width: 100%; padding: 12px !important" :value="true" type="warning" color="#f78c00"
                                    >Waiting for Approval.</v-alert
                                >
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
            <bc-dialog :value="receive_dialog" max-width="1200">
                <v-card>
                    <v-form ref="form_receive">
                        <v-card-title>
                            <span class="headline">New Purchase Receive</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeReceiveDialog"
                                :dialog-status="receive_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="receive_product[0].receive_date"
                                            :label="$t('lang.order_date')"
                                            :rules="ifValid('purchase_orders.order_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                </v-layout>
                                <div>
                                    <v-data-table
                                        :headers="purchase_order_receive_headers"
                                        :items="receive_product || []"
                                        :no-data-text="$t('lang.no_results_matching')"
                                        hide-actions
                                    >
                                        <template slot="items" slot-scope="props">
                                            <tr>
                                                <td>
                                                    <v-text-field v-model="props.item.part_id" disabled></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field v-model="props.item.quantity" disabled></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field v-model="props.item.received_quantity" disabled></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field v-model="props.item.in_transit_quantity" disabled></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field
                                                        v-model="props.item.quantity_to_receive"
                                                        @keyup="calculatePurchaseOrderReceiveReceipt($event, props.item.quantity_to_receive)"
                                                        @input="checkPurchaseOrderReceiveReceipt()"
                                                    ></v-text-field>
                                                </td>
                                                <td>
                                                    <v-text-field v-model="props.item.received_cost" @input="checkPurchaseOrderReceiveReceipt()"></v-text-field>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-container>
                        </v-card-text>
                        <v-card-actions v-if="!convert_currency">
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeReceiveDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn :class="saveReceiveReceipt == false ? 'overlay' : ''" color="success" @click="savePurchaseOrderReceiveReceipt()">{{
                                $t("lang.save")
                            }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>

            <bc-dialog :value="entity_address_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.editAddress") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close @invoke-method="invokeMethod($event)" :dialog-status="entity_address_dialog" action="close"></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="entity_address">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12 pr-0>
                                        <v-layout row>
                                            <!-- <v-flex xs6 class="primary-chip-container inner-flex">
                                                <v-chip
                                            v-if="entity_address.prime == '1'"
                                            color="primary"
                                            class="primary-chip"
                                            disabled
                                        >
                                            {{ $t('lang.primary_caps') }}
                                        </v-chip>
                                        <v-switch
                                            v-else
                                            v-model="entity_address.prime"
                                            :label="$t('lang.primary')"
                                            true-value="1"
                                            false-value="0"
                                        ></v-switch>
                                            </v-flex> -->
                                            <!-- <bc-btn-entity-action
                                        v-if="entity_address.full_single_line_address"
                                        class="ml-auto"
                                        icon="content_copy"
                                        text="Copy"
                                        @action="copyContent(entity_address.full_single_line_address)"
                                    ></bc-btn-entity-action>
                                    <bc-btn-entity-action
                                        v-if="entity_address.maps_link"
                                        icon="pin_drop"
                                        :text="$bp.xsOnly ? $t('lang.directions') : $t('lang.show_map')"
                                        :currentEntity="entity_address"
                                        :link="entity_address.maps_link"
                                    ></bc-btn-entity-action> -->
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="purchase_order.ship_location_label"
                                            :label="`${$t('lang.location_label')}`"
                                            :counter="showCounter(purchase_order.ship_location_label, 'purchase_order.ship_location_label')"
                                            :rules="ifValid('purchase_orders.ship_location_label')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="entity_address_dialog"
                                            v-model="purchase_order.ship_address1"
                                            :label="`${$t('lang.address1')} *`"
                                            :counter="showCounter(purchase_order.ship_address1, 'purchase_order.ship_address1')"
                                            :rules="ifValid('purchase_orders.ship_address1')"
                                        >
                                            <template slot="append-outer">
                                                <bc-tooltip :disabled="has_alt_address">
                                                    <template slot="activator">
                                                        <v-btn icon @mouseup.left="has_alt_address = true" tabindex="-1" :class="{ 'd-none': has_alt_address }">
                                                            <v-icon>add</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    {{ $t("lang.add_another_address") }}
                                                </bc-tooltip>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="has_alt_address">
                                        <v-text-field
                                            v-model="purchase_order.ship_address2"
                                            :label="$t('lang.address2')"
                                            :counter="showCounter(purchase_order.ship_address2, 'purchase_order.ship_address2')"
                                            :rules="ifValid('purchase_orders.ship_address2')"
                                        >
                                            <template slot="append-outer">
                                                <bc-tooltip>
                                                    <template slot="activator">
                                                        <v-btn icon @mouseup.left="has_alt_address = false" tabindex="-1">
                                                            <v-icon>remove</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    {{ $t("lang.remove") }}
                                                </bc-tooltip>
                                            </template>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="purchase_order.ship_zip_code"
                                            :label="`${$t('lang.zip_code')} *`"
                                            :counter="showCounter(purchase_order.ship_zip_code, 'purchase_order.ship_zip_code')"
                                            :rules="ifValid('purchase_orders.ship_zip_code')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs7>
                                        <v-text-field
                                            v-model="purchase_order.ship_city"
                                            :label="`${$t('lang.city')} *`"
                                            :counter="showCounter(purchase_order.ship_city, 'purchase_order.ship_city')"
                                            :rules="ifValid('purchase_orders.ship_city')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs5>
                                        <v-text-field
                                            v-model="purchase_order.ship_state"
                                            :label="`${$t('lang.state')} *`"
                                            :counter="showCounter(purchase_order.ship_state, 'purchase_order.ship_state')"
                                            :rules="ifValid('purchase_orders.ship_state')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="purchase_order.ship_country_iso_3"
                                            :label="`${$t('lang.country_id')} *`"
                                            :items="countries"
                                            item-value="country_iso_3"
                                            item-text="country_name"
                                            :propsMenu="{ top: true }"
                                        ></bc-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                        <!-- <delete-confirmation-dialog
                    ref="delete_entity_address"
                    :heading="$t('lang.delete_entity_address')"
                    :message="$t('lang.confirm_delete_message')"
                    @onConfirm="deleteAddress()"
                >
                    <v-form ref="delete_confirm_address" @submit.prevent>
                        <bc-autocomplete
                            v-if="prime && entity_address.prime == '1' && entity_address.entity_addresses_id"
                            v-model="new_prime_entity_addresses_id"
                            :label="`${$t('lang.new_primary_address')} *`"
                            :items="availableItems"
                            item-value="entity_addresses_id"
                            item-text="full_single_line_address"
                            :rules="ifValid('entity_addresses.new_prime_entity_addresses_id')"
                        ></bc-autocomplete>
                    </v-form>
                </delete-confirmation-dialog> -->
                    </v-card-text>
                    <v-card-actions>
                        <!-- <v-btn v-if="hasScope('delete') && entity_address.entity_addresses_id && (!prime || availableItems.length > 0)" color="error" @mouseup.left="$refs.delete_entity_address.openDialog()">{{ $t('lang.delete') }}</v-btn> -->
                        <v-spacer></v-spacer>
                        <v-btn color="success" @mouseup.left="close()">
                            {{ $t("lang.done") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>

            <bc-modal-email
                ref="emailDialog"
                :pdfReportName="`purchase_order_${purchase_order.purchase_order_id}.pdf`"
                :endPoint="`/purchase_orders/${purchase_order.purchase_order_id}/email`"
            ></bc-modal-email>
            <bc-address-selector ref="select_address_dialog" @eventname="updateAddress"></bc-address-selector>
            <delete-confirmation-dialog
                ref="delete_purchase_order"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_purchase_order')"
                :message="$t('lang.delete_purchase_order_confirm')"
                @onConfirm="deletePurchaseOrders()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_purchase_order_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeletePurchaseOrderDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import axios from "axios";
import _ from "lodash";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            purchase_order_headers: [
                { text: this.$t("lang.part_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.mfg_name"), sortable: false, width: "10%" },
                { text: this.$t("lang.hts_code"), sortable: false, width: "5%" },
                { text: this.$t("lang.quantity"), sortable: false, width: "7%" },
                { text: this.$t("lang.sales_unit"), sortable: false, width: "10%" },
                { text: this.$t("lang.lead_time"), sortable: false, width: "5%" },
                { text: this.$t("lang.cost_price"), sortable: false, width: "10%" },
                // { text: this.$t("lang.cost_price"), sortable: false, width: "10%" },
                {
                    text: this.$t("lang.discount"),
                    sortable: false,
                    width: "10%",
                },
                { text: this.$t("lang.line_total"), sortable: false, width: "10%" },
                { text: "", width: "3%", sortable: false },
            ],
            purchase_order_receive_headers: [
                { text: this.$t("lang.part_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.ordered"), sortable: false, width: "10%" },
                { text: this.$t("lang.received"), sortable: false, width: "10%" },
                { text: this.$t("lang.in_transit"), sortable: false, width: "10%" },
                { text: this.$t("lang.quantity_to_receive"), sortable: false, width: "10%" },
                { text: this.$t("lang.unit_cost"), sortable: false, width: "10%" },
            ],
            formData: {},
            purchase_order: {
                expedite_fee: "0.000",
                handling_charge: "0.000",
                discount_type: "A",
                freight: "0.000",
                subtotal: "0.000",
                discount: "0.000",
                total_amount: "0.000",
                customs: "0.000",
                purchase_order_details: [],
                billing_address_id: null,
                shipping_address_id: null,
                bill_address: null,
                ship_address: null,
                ship_location_label: "",
                ship_address1: "",
                ship_address2: "",
                ship_zip_code: "",
                ship_city: "",
                ship_state: "",
                ship_country_id: "",
                ship_country_name: "",
                ship_address_type: "",

                address_options: [],
                currency_id: "1",
                exchange_rate: "1.000000",
                order_date: new Date().toISOString().slice(0, 10),
                currency_prefix: "$",
                currency_suffix: "",
                currency_precision: 3,
                payment_term_id: null,
            },
            file_name: "",
            dbGetPurchaseOrder: _.debounce(this.getPurchaseOrder, 1500, { maxWait: 1500, leading: true, trailing: false }),
            receive_dialog: false,
            receive_product: [{}],
            previous_receive_number: 0,
            email_dialog: false,
            convert_currency: false,
            saveReceiveReceipt: false,
            loading: true,
            entity_address_dialog: false,
            has_alt_address: false,
            countries: null,
            hideSlot: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchPurchaseOrder", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.purchase_order) {
                        this.purchase_order = this.assignObj2(data.purchase_order, this.rules_purchase_orders);

                        if (this.current_user.login_type_id == "3" && !this.convert_currency) this.flipCurrency();
                        this.finishLoader();
                        this.refresh();
                        next();
                    } else {
                        next({ name: "purchase_orders", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchPurchaseOrder", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.purchase_order) {
                        next((vm) => {
                            vm.purchase_order = vm.assignObj2(data.purchase_order, vm.rules_purchase_orders);
                            if (vm.current_user.login_type_id == "3" && !vm.convert_currency) vm.flipCurrency();
                            vm.$store.commit("toggleMainMenu", false);
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "purchase_orders", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetOptions");
        this.$store.commit("resetPeople");
        this.$store.commit("resetCustomers");
        this.$store.commit("resetCurrencies");
        this.$store.commit("resetFeParts");
        this.$store.commit("resetPaymentTerms");
        this.$store.commit("resetDepartments");
        this.$store.commit("resetShippingCarriers");
        this.$store.commit("resetProjects");
        next();
    },
    computed: {
        ...mapState({
            rules_purchase_orders: (state) => state.purchase_orders.rules_purchase_orders,
            purchase_order_status_options: (state) => state.settings.purchase_order_status_options,
            purchase_orders: (state) => state.purchase_orders.purchase_orders,
            selectedPurchaseOrder: (state) => state.purchase_orders.selectedPurchaseOrder,
            fe_part_options_by_vendor: (state) => state.fe_parts.fe_part_options_by_vendor,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
            department_options: (state) => state.departments.department_options,
            vendor_options: (state) => state.vendors.vendor_options,
            freight_terms: (state) => state.options_categories.freight_terms,
            purchase_order_status: (state) => state.options_categories.purchase_order_status,
            sales_units: (state) => state.options_categories.sales_units,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            currencies: (state) => state.currencies.currencies,
            projects: (state) => state.projects.project_options,
        }),
        filter_customer_options() {
            return this.customer_options.filter((record) => !record.date_deleted || record.company_id === this.purchase_order.company_id);
        },
        filter_freight_terms() {
            return this.freight_terms.filter((record) => !record.date_deleted || record.option_id === this.purchase_order.freight_term_id);
        },
        filter_shipping_carriers() {
            return this.shipping_carriers.filter((record) => !record.date_deleted || record.company_id === this.purchase_order.shipping_carrier_id);
        },
        filter_currencies() {
            return this.currencies.filter((record) => !record.date_deleted || record.currency_id === this.purchase_order.currency_id);
        },
        filter_fe_part_options_by_vendor: function () {
            return function (item) {
                return this.fe_part_options_by_vendor.filter((record) => !record.date_deleted || record.vendor_map_id === item.map_id);
            };
        },
        filter_sales_units: function () {
            return function (item) {
                return this.sales_units.filter((record) => !record.date_deleted || record.option_id === item.sales_unit);
            };
        },
    },
    watch: {
        purchase_order: {
            handler: function (newValue) {
                if (!newValue.purchase_order_details) newValue.purchase_order_details = [];

                let subtotal = 0;
                for (let p of newValue.purchase_order_details) {
                    if (p.line_discount_type == "A") {
                        p.line_total = (p.cost_price * p.quantity - p.line_discount_amount).toFixed(this.purchase_order.currency_precision);
                        subtotal += parseFloat(p.line_total);
                    } else {
                        p.line_total = (p.cost_price * p.quantity - (p.cost_price * p.quantity * p.line_discount_percentage) / 100).toFixed(
                            this.purchase_order.currency_precision
                        );
                        subtotal += parseFloat(p.line_total);
                    }
                }
                newValue.subtotal = subtotal.toFixed(this.purchase_order.currency_precision);
                let total = subtotal;
                let discount = newValue.discount_type == "A" ? total - newValue.discount : total - (total * newValue.discount) / 100;
                total =
                    parseFloat(discount) +
                    parseFloat(newValue.expedite_fee) +
                    parseFloat(newValue.handling_charge) +
                    parseFloat(newValue.freight) +
                    parseFloat(newValue.customs);
                newValue.total_amount = total.toFixed(this.purchase_order.currency_precision);
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions([
            "fetchPurchaseOrder",
            "savePurchaseOrder",
            "deletePurchaseOrder",
            "printPurchaseOrder",
            "convertPurchaseOrderToBill",
            "fetchFeParts",
            "fetchPaymentTerms",
            "fetchCurrencies",
            "fetchShippingCarriers",
            "fetchDepartments",
            "fetchOptions",
            "fetchVendors",
            "fetchProjects",
            "fetchFePart",
            "fetchVendor",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (!this.purchase_order.purchase_order_details) this.purchase_order.purchase_order_details = [];
            this.purchase_order.purchase_order_details.push({
                purchase_order_id: `${this.$route.params.id}`,
                quantity: "1",
                sales_unit: "",
                model_number: "",
                name: "",
                line_discount_amount: "0.000",
                line_discount_percentage: "0.000",
                line_discount_type: "P",
                line_total: "0.000",
                cost_price: "0.000",
                in_transit_quantity: null,
            });
        },
        removeRow: function (index) {
            this.purchase_order.purchase_order_details.splice(index, 1);
        },
        changeAddress(type) {
            this.getCountries();
            this.entity_address_dialog = true;

            // let address_list = this.purchase_order.address_options ? this.purchase_order.address_options : this.company.entity_addresses || [];
            // this.$refs.select_address_dialog.showAddresses(address_list, type);
        },
        flipCurrency() {
            this.convert_currency = !this.convert_currency;
            for (let p of this.purchase_order.purchase_order_details) {
                // if convert_currency is true, then convert the discount amount to the customer currency
                // calc cost_price, cost_price, line_discount_amount if amount
                if (this.convert_currency) {
                    p.cost_price = (p.cost_price * this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                    p.cost_price = (p.cost_price * this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                    if (p.line_discount_type == "A")
                        p.line_discount_amount = (p.line_discount_amount * this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                } else {
                    p.cost_price = (p.cost_price / this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                    p.cost_price = (p.cost_price / this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                    if (p.line_discount_type == "A")
                        p.line_discount_amount = (p.line_discount_amount / this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                }
            }
            // calc discount if amount, freight, customs, handling_charge, expedite_fee
            if (this.convert_currency) {
                if (this.purchase_order.discount_type == "A")
                    this.purchase_order.discount = (this.purchase_order.discount * this.purchase_order.exchange_rate).toFixed(
                        this.purchase_order.currency_precision
                    );
                this.purchase_order.freight = (this.purchase_order.freight * this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                this.purchase_order.customs = (this.purchase_order.customs * this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                this.purchase_order.expedite_fee = (this.purchase_order.expedite_fee * this.purchase_order.exchange_rate).toFixed(
                    this.purchase_order.currency_precision
                );
                this.purchase_order.handling_charge = (this.purchase_order.handling_charge * this.purchase_order.exchange_rate).toFixed(
                    this.purchase_order.currency_precision
                );
            } else {
                if (this.purchase_order.discount_type == "A")
                    this.purchase_order.discount = (this.purchase_order.discount / this.purchase_order.exchange_rate).toFixed(
                        this.purchase_order.currency_precision
                    );
                this.purchase_order.freight = (this.purchase_order.freight / this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                this.purchase_order.customs = (this.purchase_order.customs / this.purchase_order.exchange_rate).toFixed(this.purchase_order.currency_precision);
                this.purchase_order.expedite_fee = (this.purchase_order.expedite_fee / this.purchase_order.exchange_rate).toFixed(
                    this.purchase_order.currency_precision
                );
                this.purchase_order.handling_charge = (this.purchase_order.handling_charge / this.purchase_order.exchange_rate).toFixed(
                    this.purchase_order.currency_precision
                );
            }
        },
        updateAddress(item, type) {
            if (type == "bill_address") {
                this.purchase_order.billing_address_id = item.entity_addresses_id;
                this.purchase_order.bill_location_label = item.location_label;
                this.purchase_order.bill_address1 = item.address1;
                this.purchase_order.bill_address2 = item.address2;
                this.purchase_order.bill_city = item.city;
                this.purchase_order.bill_state = item.state;
                this.purchase_order.bill_zip_code = item.zip_code;
                this.purchase_order.bill_zip_code_ext = item.zip_code_ext;
                this.purchase_order.bill_country_iso_3 = item.country_iso_3;
            } else if (type == "ship_address") {
                this.purchase_order.shipping_address_id = item.entity_addresses_id;
                this.purchase_order.ship_location_label = item.location_label;
                this.purchase_order.ship_address1 = item.address1;
                this.purchase_order.ship_address2 = item.address2;
                this.purchase_order.ship_city = item.city;
                this.purchase_order.ship_state = item.state;
                this.purchase_order.ship_zip_code = item.zip_code;
                this.purchase_order.ship_zip_code_ext = item.zip_code_ext;
                this.purchase_order.ship_country_iso_3 = item.country_iso_3;
            }
        },
        getPurchaseOrder(pg_refresh = false) {
            this.startLoader();

            this.fetchPurchaseOrder({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.purchase_order) {
                    this.purchase_order = this.assignObj2(data.purchase_order, this.rules_purchase_orders);
                    this.convert_currency = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printPurchaseOrder({
                id: `${this.$route.params.id}`,
                view_as: this.convert_currency,
            }).then((data) => {
                if (typeof data != "undefined" && data.purchase_order) {
                    if (this.dev_mode) {
                        this.file_name = data.purchase_order.file_name;
                    } else {
                        this.$refs.print.printReport(data.purchase_order.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        savePurchaseOrders() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formPurchaseOrder")) {
                    let body = this.prepForm(this.purchase_order, this.rules_purchase_orders);

                    this.savePurchaseOrder({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.purchase_order) {
                            this.$router.push({ name: "purchase_order", params: { id: data.purchase_order.purchase_order_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { purchase_order_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.savePurchaseOrder({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.purchase_order) {
                    this.purchase_order = this.assignObj2(data.purchase_order, this.rules_purchase_orders);
                    this.convert_currency = false;
                }
            });
        },
        deletePurchaseOrders() {
            this.deletePurchaseOrder({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.delete_purchase_order_details.close();
                    this.validationOff();
                    this.$router.push({ name: "purchase_orders" });
                }
                this.toggleModalLoader(false);
            });
        },
        /*convertToOrder() {
            this.status_loader = true;
            let body = { purchase_order_id: `${this.$route.params.id}` };

            this.convertPurchaseOrderToOrder({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.order) {
                    this.$router.push({ name: "order", params: { id: data.order.order_id } });
                }
            });
        },*/
        convertToBill() {
            this.status_loader = true;
            let body = { purchase_order_id: `${this.$route.params.id}` };

            this.convertPurchaseOrderToBill({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.bill) {
                    this.$router.push({ name: "bill", params: { id: data.bill.bill_id } });
                }
            });
        },
        selectCustomer(company_id) {
            if (company_id == null) {
                return;
            } else {
                this.fetchVendor({ id: company_id }).then((data) => {
                    if (data.vendor) {
                        this.company = data.vendor;
                        this.purchase_order.currency_id = this.company.currency_id ? this.company.currency_id : "1";
                        this.purchase_order.exchange_rate = this.company.exchange_rate ? this.company.exchange_rate : "1.000000";
                        this.purchase_order.payment_term_id = this.company.payment_term_id;

                        this.purchase_order.order_date = new Date().toISOString().slice(0, 10);

                        this.purchase_order.address_options = this.company.entity_addresses ? this.company.entity_addresses : [];

                        // let ship_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "shipping")[0] : null;
                        // this.purchase_order.shipping_address_id = ship_address && ship_address.entity_addresses_id ? ship_address.entity_addresses_id : null;
                        // this.purchase_order.ship_location_label = ship_address && ship_address.location_label ? ship_address.location_label : null;
                        // this.purchase_order.ship_address1 = ship_address && ship_address.address1 ? ship_address.address1 : null;
                        // this.purchase_order.ship_address2 = ship_address && ship_address.address2 ? ship_address.address2 : null;
                        // this.purchase_order.ship_city = ship_address && ship_address.city ? ship_address.city : null;
                        // this.purchase_order.ship_state = ship_address && ship_address.state ? ship_address.state : null;
                        // this.purchase_order.ship_zip_code = ship_address && ship_address.zip_code ? ship_address.zip_code : null;
                        // this.purchase_order.ship_zip_code_ext = ship_address && ship_address.zip_code_ext ? ship_address.zip_code_ext : null;
                        // this.purchase_order.ship_country_iso_3 = ship_address && ship_address.country_iso_3 ? ship_address.country_iso_3 : null;

                        this.purchase_order.ship_location_label = "DOWA THT AMERICA, INC.";
                        this.purchase_order.ship_address1 = "2130 S. Woodland Cir";
                        this.purchase_order.ship_address2 = null;
                        this.purchase_order.ship_city = "Bowling Green";
                        this.purchase_order.ship_state = "Ohio";
                        this.purchase_order.ship_zip_code = "43402";
                        this.purchase_order.ship_zip_code_ext = null;
                        this.purchase_order.ship_country_iso_3 = "USA";
                        this.purchase_order.ship_address_type = "shipping";
                        this.purchase_order.ship_country_id = "140";

                        // let bill_address = this.company.entity_addresses ? this.company.entity_addresses.find((x) => x.address_type == "billing") : null;
                        // this.purchase_order.billing_address_id = bill_address && bill_address.entity_addresses_id ? bill_address.entity_addresses_id : null;
                        this.purchase_order.bill_location_label = "DOWA THT AMERICA, INC.";
                        this.purchase_order.bill_address1 = "2130 S. Woodland Cir";
                        this.purchase_order.bill_address2 = null;
                        this.purchase_order.bill_city = "Bowling Green";
                        this.purchase_order.bill_state = "Ohio";
                        this.purchase_order.bill_zip_code = "43402";
                        this.purchase_order.bill_zip_code_ext = null;
                        this.purchase_order.bill_country_iso_3 = "USA";

                        if (this.purchase_order.company_id != null)
                            this.fetchFeParts({
                                body: {
                                    options: 1,
                                    by_vendor: 1,
                                    vendor_id: this.purchase_order.company_id,
                                    with_trashed: this.purchase_order.purchase_order_id ? "1" : "0",
                                    include_global: 1,
                                },
                            });
                    }
                });
            }
        },
        setDetailDiscount(index) {
            let part = this.purchase_order.purchase_order_details[index];
            if (part.line_discount_type == "P") {
                part.line_discount_type = "A";
                part.line_discount_amount = part.line_discount_percentage;
                part.line_discount_percentage = "0.000";
            } else {
                part.line_discount_type = "P";
                part.line_discount_percentage = part.line_discount_amount;
                part.line_discount_amount = "0.000";
            }
        },
        setDiscount() {
            if (this.purchase_order.discount_type == "P" || this.purchase_order.discount_type == "%") {
                this.purchase_order.discount_type = "A";
            } else {
                this.purchase_order.discount_type = "P";
            }
        },
        handleChangePart(index, item) {
            // Get the part from the parts array based on the part_id
            let partObj = this.fe_part_options_by_vendor.find((x) => x.vendor_map_id == item.map_id);
            this.fetchFePart({ id: partObj.part_id }).then((data) => {
                if (typeof data !== "undefined" && data.fe_part) {
                    partObj = data.fe_part;
                    this.purchase_order.purchase_order_details[index].part_id = partObj.part_id;
                    this.purchase_order.purchase_order_details[index].cost_price = partObj.part_cost;
                    this.purchase_order.purchase_order_details[index].unit_price = partObj.sales_price;
                    this.purchase_order.purchase_order_details[index].model_number = partObj.model_number;
                    this.purchase_order.purchase_order_details[index].sales_unit = partObj.sales_unit;
                    this.purchase_order.purchase_order_details[index].name = partObj.name;
                    this.purchase_order.purchase_order_details[index].lead_time = partObj.lead_time;
                    this.purchase_order.purchase_order_details[index].hts_code = partObj.hts_code;
                    this.purchase_order.purchase_order_details[index].vendor_sku = partObj.preferred_vendor_sku;

                    this.$refs[`${index}_quantity`].$el.querySelector("input").focus();
                }
            });
        },
        setExchangeRate(currency_id) {
            let exchange_rate = this.currencies.find((x) => x.currency_id == currency_id);
            this.purchase_order.currency_id = currency_id;
            this.purchase_order.exchange_rate = exchange_rate.exchange_rate ? exchange_rate.exchange_rate : "1.000000";
        },
        closeReceiveDialog() {
            this.receive_dialog = false;
            this.validationOff();
            this.toggleModalLoader(false);
        },
        setupPurchaseOrderReceiveProduct(detail_id) {
            this.receive_dialog = !this.receive_dialog;
            // Get the purchase order detail from the purchase order details array based on the detail_id
            if (this.receive_dialog == true) {
                let detail = this.purchase_order.purchase_order_details.find((x) => x.purchase_order_detail_id == detail_id);
                detail = Object.assign({}, detail);
                this.receive_product = [];
                this.receive_product.push(detail);
                if (!this.receive_product[0].receive_date || this.receive_product[0].receive_date == null)
                    this.receive_product[0].receive_date = new Date().toISOString().slice(0, 10);
                if (this.receive_product[0].quantity_to_receive == null) this.receive_product[0].quantity_to_receive = "0";
                if (this.receive_product[0].in_transit_quantity == null) this.receive_product[0].in_transit_quantity = this.receive_product[0].quantity;
                if (this.receive_product[0].received_quantity == null) this.receive_product[0].received_quantity = "0";
                if (!this.receive_product[0].received_cost) this.receive_product[0].received_cost = detail.cost_price;
                if (!this.receive_product[0].vendor_id) this.receive_product[0].vendor_id = this.purchase_order.company_id;
                this.checkPurchaseOrderReceiveReceipt();
            }
        },
        calculatePurchaseOrderReceiveReceipt: _.debounce(function (event, amount) {
            const keyCode = event.keyCode || event.which;
            const keyValue = event.key;

            if ((keyCode === 8 && keyValue === "Backspace") || (keyCode === 46 && keyValue === "Delete")) {
                if (amount == "" || amount == null) amount = 0;

                let add_amount = parseInt(this.previous_receive_number) - parseInt(amount);
                this.receive_product[0].in_transit_quantity = parseInt(this.receive_product[0].in_transit_quantity) + parseInt(add_amount);
                this.receive_product[0].received_quantity = parseInt(this.receive_product[0].received_quantity) - parseInt(add_amount);
            } else {
                this.receive_product[0].in_transit_quantity = parseInt(this.receive_product[0].in_transit_quantity) - parseInt(amount);
                this.receive_product[0].received_quantity = parseInt(this.receive_product[0].received_quantity) + parseInt(amount);
            }

            this.previous_receive_number = amount;
        }, 500),
        savePurchaseOrderReceiveReceipt() {
            let body = {
                part_id: this.receive_product[0].part_id,
                purchase_order_id: this.purchase_order.purchase_order_id,
                purchase_order_detail_id: this.receive_product[0].purchase_order_detail_id,
                received_quantity: this.receive_product[0].quantity_to_receive,
                received_cost: this.receive_product[0].received_cost,
                receipt_date: this.receive_product[0].receive_date,
                vendor_id: this.receive_product[0].vendor_id,
            };
            this.$store
                .dispatch("saveInventoryReceipt", {
                    url: `procurement/purchase_order/${this.purchase_order.purchase_order_id}/inventory_receipt`,
                    method: "post",
                    commit: true,
                    body: body,
                })
                .then((data) => {
                    if (data.code == "200") {
                        this.receive_dialog = false;
                        this.receive_product = [{}];
                        this.purchase_order = this.assignObj2(data.purchase_order, this.rules_purchase_orders);
                    }
                });
        },
        setEmailDialog() {
            this.validationOff();
            this.$refs.emailDialog.showEmail();
        },
        checkPurchaseOrderReceiveReceipt() {
            if (this.receive_dialog == false) return;
            if (
                this.receive_product[0].quantity_to_receive == null ||
                this.receive_product[0].quantity_to_receive == "" ||
                this.receive_product[0].quantity_to_receive == 0 ||
                this.receive_product[0].received_cost == ""
            ) {
                this.saveReceiveReceipt = false;
            } else {
                this.saveReceiveReceipt = true;
            }
        },
        approveUnapprovePurchaseOrder() {
            if (this.purchase_order.approved == 1) {
                this.purchase_order.approved = 0;
            } else {
                this.purchase_order.approved = 1;
            }

            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formPurchaseOrder")) {
                    let body = { purchase_order_id: `${this.$route.params.id}`, approved: this.purchase_order.approved };

                    this.savePurchaseOrder({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.purchase_order) {
                            this.purchase_order = this.assignObj2(data.purchase_order, this.rules_purchase_orders);
                        }
                    });
                }
            });
        },
        getCountries() {
            this.$store
                .dispatch("fetchLocale", {
                    url: "locales/countries",
                    method: "get",
                    stateProperty: "locale_countries",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.countries = data.locale_countries;
                    }
                });
        },
        close() {
            this.entity_address_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        async refresh(force = false) {
            this.startLoader();
            if (force == true) {
                this.fetchPurchaseOrder({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.purchase_order) {
                        this.purchase_order = this.assignObj2(data.purchase_order, this.rules_purchase_orders);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            }
            if (this.current_user.login_type_id == "1") {
                if (this.vendor_options.length == 0 || force == true)
                    this.fetchVendors({ body: { options: 1, with_trashed: this.purchase_order.purchase_order_id ? "1" : "0" } });
                if (this.shipping_carriers.length == 0 || force == true)
                    this.fetchShippingCarriers({ body: { options: 1, with_trashed: this.purchase_order.purchase_order_id ? "1" : "0", department_id: "1" } });
            }

            if (this.currencies.length == 0 || force == true)
                this.fetchCurrencies({ body: { options: 1, with_trashed: this.purchase_order.purchase_order_id ? "1" : "0" } });

            if (this.purchase_order.company_id != null || force == true)
                this.fetchFeParts({
                    body: {
                        options: 1,
                        by_vendor: 1,
                        vendor_id: this.purchase_order.company_id,
                        with_trashed: this.purchase_order.purchase_order_id ? "1" : "0",
                        include_global: 1,
                    },
                });

            if (this.purchase_order.request_date == null || force == true) this.purchase_order.request_date = new Date().toISOString().slice(0, 10);

            if (this.freight_terms == 0 || force == true)
                this.fetchOptions({ body: { slug: "freight_terms", with_trashed: this.purchase_order.purchase_order_id ? "1" : "0", options: 1 } });

            if (this.purchase_order_status == 0 || force == true)
                this.fetchOptions({ body: { slug: "purchase_order_status", with_trashed: this.purchase_order.purchase_order_id ? "1" : "0", options: 1 } });

            if (this.sales_units == 0 || force == true)
                this.fetchOptions({ body: { slug: "sales_units", sort_by: "0", with_trashed: this.purchase_order.purchase_order_id ? "1" : "0", options: 1 } });

            if (this.department_options.length == 0 || force == true)
                this.fetchDepartments({ body: { options: 1, with_trashed: this.purchase_order.purchase_order_id ? "1" : "0" } });

            if (!this.purchase_order.department_id) this.purchase_order.department_id = this.currUserField("department_id");

            if (this.payment_terms.length == 0 || force == true)
                this.fetchPaymentTerms({ body: { options: 1, with_trashed: this.purchase_order.purchase_order_id ? "1" : "0" } });

            if (this.projects.length == 0 || force == true) await this.fetchProjects({ body: { options: 1 } });

            this.loading = false;
            this.finishLoader();
        },
        resetLine(index, item) {
            this.purchase_order.purchase_order_details[index].part_id = null;
            this.purchase_order.purchase_order_details[index].cost_price = null;
            this.purchase_order.purchase_order_details[index].unit_price = null;
            this.purchase_order.purchase_order_details[index].model_number = null;
            this.purchase_order.purchase_order_details[index].sales_unit = null;
            this.purchase_order.purchase_order_details[index].name = null;
            this.purchase_order.purchase_order_details[index].lead_time = null;
            this.purchase_order.purchase_order_details[index].hts_code = null;
            this.purchase_order.purchase_order_details[index].line_description = null;
            this.purchase_order.purchase_order_details[index].map_id = null;

            this.$nextTick(() => {
                this.$refs[`${index}_map_id`].$children[0].focus();
                this.$refs[`${index}_map_id`].$children[0].isMenuActive = true;
            });
        },
    },
};
</script>
<style lang="css">
.overlay {
    opacity: 0.25;
    pointer-events: none;
}

.custom-table .v-table tbody tr td {
    vertical-align: top !important;
}

.full-height-tile .v-list__tile {
    height: 100%;
}

.custom-textarea textarea {
    padding-right: 0px !important;
    font-size: 14px;
    margin-top: 0px !important;
    padding: 4px !important;
}

.custom-textarea .v-input__slot {
    padding: 0px !important;
    border: 1px solid rgba(0, 0, 0, 0.54) !important;
}
</style>
